import type {
  ImpersonateResponse,
  LoginBody,
  LoginResponse,
  MeResponse,
} from '../../shared/types/index.js';
import { request } from './client.js';

export function login(body: LoginBody): Promise<LoginResponse> {
  return request<LoginResponse>('/auth/login', { method: 'POST', body });
}

export function fetchMe(): Promise<MeResponse> {
  return request<MeResponse>('/auth/me');
}

export function logout(): Promise<unknown> {
  return request('/auth/logout', { method: 'POST' });
}

/** Admin only: a session acting as the given account. */
export function impersonate(accountId: string): Promise<ImpersonateResponse> {
  return request<ImpersonateResponse>('/auth/impersonate', { method: 'POST', body: { accountId } });
}
